module.exports = __webpack_public_path__ + "media/images/emblems/Ernen-coat_of_arms-601fc3c92aaaa78369e33f31edd3c1d6.svg";